import React from 'react';
import CtaButton2 from '../CallToAction/ctaButton2';
import '../../styles/landing_page.css';
import './styles/HowItWorks.css';

function HowItWorks() {
	return (
		<div className="how_it_works__container">
			<div className="how_it_works__content">
				<h1>How It Works</h1>
				<p>
					Thumbs is a web extension that makes it easier for users to rate and review products on Amazon.
					Anyone with the extension can get a quick impression of an item by checking out the number of
					upvotes and downvotes it has. The extension allows logged in customers to give a product a thumbs up
					or thumbs down.
				</p>
				<h1>Background</h1>
				<p>
					Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
					et dolore magna aliqua. Nulla posuere sollicitudin aliquam ultrices. Ut enim blandit volutpat
					maecenas volutpat blandit aliquam etiam. Praesent semper feugiat nibh sed pulvinar proin gravida.
					Lacus vel facilisis volutpat est velit. Vitae justo eget magna fermentum iaculis eu non diam. Velit
					dignissim sodales ut eu. Faucibus purus in massa tempor nec. Mattis rhoncus urna neque viverra justo
					nec ultrices dui.
				</p>
				<h1>Key Features</h1>
				<p>
					Ligula ullamcorper malesuada proin libero nunc consequat interdum. Dictumst quisque sagittis purus
					sit amet volutpat consequat mauris nunc. Euismod nisi porta lorem mollis aliquam ut porttitor. Non
					blandit massa enim nec. Arcu felis bibendum ut tristique et egestas. Et ultrices neque ornare aenean
					euismod elementum nisi quis. Mattis aliquam faucibus purus in massa tempor nec. Amet nisl purus in
					mollis nunc sed id. Pharetra pharetra massa massa ultricies mi quis hendrerit dolor magna.
				</p>
				<CtaButton2 />
			</div>
		</div>
	);
}

export default HowItWorks;
